import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import {
  CustomTooltipModule,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import { ConditionLogic } from '@principle-theorem/principle-core';
import {
  ConditionLogicConfigurationCollection,
  TemplateScope,
} from '@principle-theorem/principle-core/interfaces';
import { ConditionLogicSummaryComponent } from '../condition-logic-summary/condition-logic-summary.component';
import { IconChipComponent } from '../icon-chip/icon-chip.component';
import { ConnectedPosition } from '@angular/cdk/overlay';

@Component({
  selector: 'pr-condition-logic-summary-chip',
  templateUrl: './condition-logic-summary-chip.component.html',
  styleUrl: './condition-logic-summary-chip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgCommonModule,
    CustomTooltipModule,
    IconChipComponent,
    ConditionLogicSummaryComponent,
  ],
  host: { class: 'flex flex-row gap-0' },
})
export class ConditionLogicSummaryChipComponent {
  scope = input.required<TemplateScope>();
  conditions = input.required<ConditionLogicConfigurationCollection>();
  conditionCount = computed(() =>
    ConditionLogic.getConditionCount(this.conditions())
  );
  positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
    },
  ];
}
